<template>
  <div id="change-pwd" style="width: 400px; margin: auto">
    <b-form>
      <b-form-group
        id="input-group-1"
        label="旧密码:"
        label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.oldPassword"
          type="password"
          required
          placeholder="输入旧密码"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="新密码:"
        label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.newPassword"
          type="password"
          required
          placeholder="输入新密码"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-3"
        label="确认新密码:"
        label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="form.confirmNewPassword"
          type="password"
          required
          placeholder="确认新密码"
        ></b-form-input>
      </b-form-group>
      <b-button @click="onSubmit" variant="primary">确认修改</b-button>
    </b-form>
  </div>
</template>
<script>
import { changePwd, logout } from '../../api/user'
import Tool from '../../util/tool'
export default {
  data () {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      }
    }
  },
  methods: {
    onSubmit () {
      if (!this.form.oldPassword || !this.form.newPassword || !this.form.confirmNewPassword) {
        this.$toasted.global.pop_error('请输入密码')
        return
      }
      if (this.form.newPassword !== this.form.confirmNewPassword) {
        this.$toasted.global.pop_error('两次输入密码不匹配')
        return
      }
      if (this.form.newPassword === this.form.oldPassword) {
        this.$toasted.global.pop_error('新密码不能与旧密码一样')
        return
      }
      if (this.form.newPassword.length < 8 || this.form.newPassword.length > 20) {
        this.$toasted.global.pop_error('新密码必须为8-20个字符')
        return
      }
      changePwd(this.form).then(resp => {
        if (Tool.returnSuccess(resp)) {
          this.$toasted.global.pop_success('修改密码成功')
          logout().then(logoutResp => {
            this.$router.push({
              path: `/login`
            })
          }).catch()
        } else {
          this.$toasted.global.pop_error(resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('修改失败：' + error)
      })
    }
  }
}
</script>
